<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_iii"></a><strong>When Money Talks</strong></h1>
<div class="linea"><hr/></div>
<p class="subtitle"><strong>The High Price of “Free” Speech and the Selling of Democracy</strong></p>
<p class="author"><strong>Derek D. Cressman</strong></p>
<p class="pub"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?39c89ad8